import { createContext, useContext, useMemo, useState } from 'react';

type PromoContextType = {
  promoCode?: string;
  setPromoCode: (code?: string) => void;
};
export const PromoContext = createContext<PromoContextType>({
  promoCode: undefined,
  setPromoCode: () => {},
});

export const PromoProvider = ({ children }: { children: React.ReactNode }) => {
  const [promoCode, setPromoCode] = useState<string | undefined>(undefined);

  const contextValue = useMemo(
    () => ({
      promoCode,
      setPromoCode,
    }),
    [promoCode],
  );

  return <PromoContext.Provider value={contextValue}>{children}</PromoContext.Provider>;
};

export const usePromoContext = () => {
  const context = useContext(PromoContext);
  if (context === undefined) {
    throw new Error('usePromoContext must be used within a PromoProvider');
  }
  return context;
};
